import './record-featured-card.scss'

import { empty } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { defineComponent, PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { faTabletAlt } from '@fortawesome/free-solid-svg-icons'

import { RecordFeatured, getTranslatedString } from '@skinsoft/types'
import { AuditRoutes } from '@skinsoft/const'
import { itemSelectors, specimenSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { Touchable } from '@skinsoft/ui'

export const RecordFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sTouchable: Touchable
    },
    props: {
        recordFeatured: {
            type: Object as PropType<RecordFeatured>,
            required: true,
        },
        fromCache: {
            type: Boolean
        },
    },
    template: require('./record-featured-card.html'),
    data() {
        return {
            ready: false,
            itemLocation: "",
            itemInventoryNumber: "",
            // Icons
            localIcon: faTabletAlt,
        }
    },
    computed: {
        // Explicit return type required: a computed getter that reads `this` without one creates a
        // circular type Vue/TS can't resolve, which silently turns every method in this component into `never`.
        formatCurrentState(): TranslateResult {
            // Little hack to avoid diplaying on state key in offline mode
            const fromI18n = this.$t(`state.${this.recordFeatured.currentState}`);
            return fromI18n === `state.${this.recordFeatured.currentState}` ?
                this.recordFeatured.currentState : this.$t(`state.${this.recordFeatured.currentState}`);
        },
    },
    methods: {
        subscribeToItem() {
            const locale = this.getAppLocale()

            if(this.recordFeatured.linkedItemIdentifier) {
                this.itemInventoryNumber = getTranslatedString(
                    this.recordFeatured.linkedItemIdentifier,
                    locale
                )

                if(this.recordFeatured.currentLocationId) {
                    this.$locationDataStore.fetchOne(this.recordFeatured.currentLocationId)
                        .subscribe(location => {
                            this.itemLocation = getTranslatedString(location.translatedTitle, locale) as string;
                            this.ready = true
                        })
                } else {
                    this.ready = true
                }

            } else {
                this.$itemDataStore.fetchOne(this.recordFeatured.linkedItemId)
                    .pipe(
                        switchMap(
                            item => {
                                this.itemInventoryNumber = itemSelectors.identifier(item, locale)
                                const locId = itemSelectors.realTimeLocation(item)
                                if (locId) {
                                    return this.$locationDataStore.fetchOne(locId)
                                }
                                this.ready = true;
                                return empty();
                            }
                        )
                    )
                    .subscribe(
                        location => {
                            this.itemLocation = getTranslatedString(location.translatedTitle, locale) as string;
                            this.ready = true;
                        }
                    )
            }
        },
        openRecord() {
            this.$router.push({ name: AuditRoutes.RECORD, params: { campaignId: this.$route.params.campaignId, recordId: this.recordFeatured.id } })
        },
    },
    watch: {
        recordFeatured: {
            handler() {
                if (this.recordFeatured) {
                    this.subscribeToItem();
                }
            },
            immediate: true,
            deep: true,
        },
    },
})
